// @flow
import * as React from 'react';
import type { FeatureConfig } from './flowTypes';

const FeatureContext = React.createContext<FeatureConfig>({});

export default FeatureContext;
